import { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface VercelDeployFormProps {
  projectId: string;
  projectName?: string;
  savedTeamId?: string;
  savedProjectName?: string;
  onConfigChange: (projectName: string, teamId: string) => void;
}

export function VercelDeployForm({
  projectId,
  projectName: initialProjectName,
  savedTeamId,
  savedProjectName,
  onConfigChange,
}: VercelDeployFormProps) {
  const [projectName, setProjectName] = useState(savedProjectName || initialProjectName || projectId);
  const [teamId, setTeamId] = useState(savedTeamId || '');

  useEffect(() => {
    onConfigChange(projectName, teamId);
  }, [projectName, teamId, onConfigChange]);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-sm font-medium">Project Name</Label>
        <Input
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          placeholder={initialProjectName || projectId}
          className="h-10 bg-background"
        />
      </div>

      <div className="rounded-lg bg-muted/50 border border-border/50 p-3 space-y-1">
        <p className="text-xs text-muted-foreground">
          Your site will be available at:
        </p>
        <p className="text-sm font-mono font-medium text-foreground">
          {projectName || projectId}.vercel.app
        </p>
      </div>

      <div className="space-y-2">
        <Label className="text-sm font-medium">Team ID <span className="text-muted-foreground font-normal">(optional)</span></Label>
        <Input
          value={teamId}
          onChange={(e) => setTeamId(e.target.value)}
          placeholder="Leave empty for personal account"
          className="h-10 bg-background"
        />
        <p className="text-xs text-muted-foreground">
          Deploy to a team account instead of your personal account
        </p>
      </div>
    </div>
  );
}
